import * as React from "react";
import { useDialog } from "@shared-ui/dialog-context";
import { ContentProps } from "components/flexComponents/Editorial/typings";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkCard, UitkCardContentSection, UitkCardActionArea } from "uitk-react-cards";
import { UitkTertiaryButton, UitkButtonSize } from "uitk-react-button";
import { EditorialModel } from "typings/microserviceModels/content-flex-module";
import { decorateEditorialHtml } from "components/flexComponents/Editorial/ContentUtilities";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";

export const EditorialInfoView = ({ items, props }: { items: EditorialModel[]; props: ContentProps }) => {
  const moreInfoRef = React.createRef<HTMLButtonElement>();
  const [, dialogActions, EditorialInfoDialogComponent] = useDialog("more-info");

  /* istanbul ignore next */
  const closeDialog = () => {
    dialogActions.closeDialog();

    if (moreInfoRef && moreInfoRef.current && typeof moreInfoRef.current.focus === "function") {
      moreInfoRef.current.focus();
    }
  };

  const { formatText } = useLocalization();

  return (
    <div className="uitk-type-paragraph-300" data-fm-content={items[0].id}>
      {items[0].title && (
        <UitkHeading tag="h2" size={4}>
          {items[0].title}
        </UitkHeading>
      )}

      {items[0].text && (
        <div className="all-t-padding-two uitk-type-300 infoMessage" onClick={dialogActions.openDialog as any}>
          <span dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
          <UitkIcon name="info_outline" size={UitkIconSize.SMALL} />
        </div>
      )}
      <EditorialInfoDialogComponent>
        <InfoDialog
          infoText={items[1].text}
          closeDialog={closeDialog}
          buttonText={formatText("editorial.moreInfo.dismissButton.label")}
        />
      </EditorialInfoDialogComponent>
    </div>
  );
};

const InfoDialog = ({
  infoText,
  closeDialog,
  buttonText,
}: {
  infoText?: string;
  closeDialog: () => void;
  buttonText: string;
}) => {
  const { useRef, useEffect } = React;
  const dialogRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (dialogRef && dialogRef.current) {
      dialogRef.current.focus();
    }
  }, []);

  return (
    <UitkCard className="editorialInfoDialog">
      <UitkCardContentSection>
        <UitkLayoutGrid columns={1}>
          <UitkLayoutGridItem>
            <UitkText size={300}>
              {infoText && <div dangerouslySetInnerHTML={decorateEditorialHtml(infoText)} />}
            </UitkText>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
        <UitkCardActionArea>
          <UitkTertiaryButton onClick={closeDialog} size={UitkButtonSize.LARGE} isFullWidth domRef={dialogRef}>
            {buttonText}
          </UitkTertiaryButton>
        </UitkCardActionArea>
      </UitkCardContentSection>
    </UitkCard>
  );
};
